import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// One clickable header for a tab group.
export default function TabHeader({
  name,
  activeName,
  onClick,
  className,
  children,
  a11yKeyboard,
  a11yRolesErb,
}) {
  const isActive = name === activeName;
  const classes = classnames(
    'tab-header',
    isActive ? 'active' : 'inactive',
    className,
  );

  if (a11yRolesErb) {
    return (
      <button
        role="tab"
        id={`tab-${name}`}
        aria-selected={isActive}
        aria-controls={`tabpanel-${name}`}
        tabIndex={isActive ? 0 : -1}
        onClick={onClick}
        className={classes}
      >
        {children}
      </button>
    );
  }

  const a11yAttrs = a11yKeyboard
    ? {
        role: 'tab',
        id: `tab-${name}`,
        'aria-selected': isActive,
        'aria-controls': `tabpanel-${name}`,
        tabIndex: isActive ? 0 : -1,
        onKeyDown: (ev) => {
          if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault();
            onClick();
          }
        },
      }
    : {};

  return (
    <div onClick={onClick} className={classes} {...a11yAttrs}>
      {children}
    </div>
  );
}

TabHeader.propTypes = {
  activeName: PropTypes.string,
  name: PropTypes.string.isRequired,
  // On click, calls this callback.
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
  a11yKeyboard: PropTypes.bool,
  a11yRolesErb: PropTypes.bool,
};

TabHeader.defaultProps = {
  activeName: null,
  onClick: () => {},
  className: '',
  a11yKeyboard: false,
  a11yRolesErb: false,
};
